// extracted by mini-css-extract-plugin
export default {"actionplan":"app-qualityControl-flags-FlagSingleActionPlan-module__zByDx8lIDxkGFzJA6Psz"};